import { combineReducers } from 'redux'
import browser from './browser'
import router from './router'
import press from './press'

const appReducer = combineReducers({ browser, location: router, press })

export default appReducer
